import React, { useState } from "react";
import { Icon } from "../../icons/icons";
import { useTranslation } from "../../context/TranslationContext";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";

const IncludedPrice = (props) => {
  const { inludedPrice, notIncludedPrice } = useTranslation();
  const data = [
    {
      title: inludedPrice,
      items: props.data[0],
    },
    {
      title: notIncludedPrice,
      items: props.data[1],
    },
  ];
  const [active, setActive] = useState(0);

  const Item = ({ text }) => {
    return (
      <li className="flex content-center items-center mb-5  w-1/2">
        <div className="iconsImgFilter">
          {process.env.NEXT_PUBLIC_THEME == "theme-second" ? (
            <FaHeart />
          ) : (
            <Icon name={"DetailIncludedPrice"} />
          )}
        </div>
        <span className="font-bold text-sm ml-3 text-brand-gray-2">{text}</span>
      </li>
    );
  };

  const ListItem = ({ items, active }) => {
    return (
      <ul className={active ? "flex flex-wrap" : "hidden"}>
        {items && items.map((item, i) => <Item text={item} key={i} />)}
      </ul>
    );
  };

  return (
    <div className="mt-6 lg:mt-11 w-full lg:px-4 xl:px-0">
      <div className="flex justify-between font-bold text-sm mb-7">
        {data &&
          data.map(
            (tab, i) =>
              tab.items.length > 0 && (
                <button
                  key={i}
                  onClick={(event) => setActive(i)}
                  className={active === i ? "active opacity-100" : "opacity-30"}
                >
                  {tab.title}
                </button>
              )
          )}
      </div>
      <ListItem active={true} items={data[active].items} />
    </div>
  );
};

export default IncludedPrice;
